export const defaultLocation = {
  latitude: 39.928359,
  longitude: 116.416334,
  area: '东城区',
  areaId: 395,
  city: '北京市',
  cityId: 37,
  province: '北京市',
  provinceId: 37,
};
